const rolesQueryKeys = {
  all: ['acl-roles'] as const,
  list: () => [...rolesQueryKeys.all, 'list'] as const,
  actions: () => [...rolesQueryKeys.all, 'actions'] as const,
  matrix: (roleId: string) => [...rolesQueryKeys.all, 'matrix', roleId] as const,
};

export default rolesQueryKeys;
